import { LottieIcon } from '../LottieIcon'

interface Christmas2025tagProps {
  visible?: boolean
}

export function Christmas2025tag({ visible = false }: Christmas2025tagProps) {
  return (
    <div style={{ marginLeft: '-4px' }}>
      <LottieIcon
        src="/Lottie/Christmas2025tag.json"
        width={30}
        height={30}
        autoplay={visible}
        loop={false}
      />
    </div>
  )
}
